// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ClientDetailsOverviewPageQueryVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
}>;


export type ClientDetailsOverviewPageQuery = { __typename?: 'Query', documents: { __typename?: 'DocumentConnection', edges?: Array<{ __typename?: 'DocumentEdge', node?: { __typename?: 'Document', id: string } | null } | null> | null }, households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: (
        { __typename?: 'Household', id: string }
        & ClientDetailsOverviewPage_HouseholdFragment
      ) | null } | null> | null }, householdAssetsSummary: (
    { __typename?: 'HouseholdAssetsSummary' }
    & ClientDetailsOverviewPage_HouseholdAssetsSummaryFragment
  ) };

export type ClientDetailsOverviewPage__ClientProfileFragment = { __typename?: 'ClientProfile', id: string, firstName: string, lastName: string, gstExclusionUsed: CurrencyUSD, displayName: string, lifetimeExclusionUsed: CurrencyUSD, currentAnnualExclusionUsed: CurrencyUSD, totalAnnualExclusionUsed: CurrencyUSD, remainingStateExemption: CurrencyUSD, stateExemptionUsed: CurrencyUSD, totalStateExemption: CurrencyUSD, address?: { __typename?: 'Address', id: string, stateCode: string } | null, dsue?: { __typename?: 'DSUEPortability', id: string, amount: CurrencyUSD, eventDate: Time } | null };

export type ClientDetailsOverviewPage_HouseholdFragment = { __typename?: 'Household', id: string, displayName: string, estateValueMetrics: (
    { __typename?: 'HouseholdMetrics' }
    & ClientDetailsOverviewPage_HouseholdMetricsFragment
  ), clientPerformanceReport: (
    { __typename?: 'ClientOverallPerformanceReport' }
    & ClientDetailsOverviewPage_ClientDetailsOverviewPageQueryFragment
  ), possiblePrimaryClients: Array<(
    { __typename?: 'ClientProfile' }
    & ClientDetailsOverviewPage__ClientProfileFragment
  )>, entities: { __typename?: 'EntityConnection', totalCount: number, edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string } | null } | null> | null } };

export type ClientDetailsOverviewPage_HouseholdMetricsFragment = { __typename?: 'HouseholdMetrics', totalEstateValue: CurrencyUSD, inEstateValue: CurrencyUSD, outOfEstateValue: CurrencyUSD, outOfEstateCharityValue: CurrencyUSD, outOfEstateFamilyValue: CurrencyUSD };

export type ClientDetailsOverviewPage_HouseholdAssetsSummaryFragment = { __typename?: 'HouseholdAssetsSummary', liquidValue: CurrencyUSD, liquidPercentage: Percent, inEstateLiquidValue: CurrencyUSD, inEstateLiquidPercentage: Percent, outOfEstateLiquidValue: CurrencyUSD, outOfEstateLiquidPercentage: Percent };

export type ClientDetailsOverviewPage_ClientDetailsOverviewPageQueryFragment = { __typename?: 'ClientOverallPerformanceReport', totalWealthTransferred: CurrencyUSD, impliedEstateTaxSavings: CurrencyUSD };

export const Operations = {
  Query: {
    ClientDetailsOverviewPage: 'ClientDetailsOverviewPage' as const
  },
  Fragment: {
    ClientDetailsOverviewPage__ClientProfile: 'ClientDetailsOverviewPage__ClientProfile' as const,
    ClientDetailsOverviewPage_Household: 'ClientDetailsOverviewPage_Household' as const,
    ClientDetailsOverviewPage_HouseholdMetrics: 'ClientDetailsOverviewPage_HouseholdMetrics' as const,
    ClientDetailsOverviewPage_HouseholdAssetsSummary: 'ClientDetailsOverviewPage_HouseholdAssetsSummary' as const,
    ClientDetailsOverviewPage_ClientDetailsOverviewPageQuery: 'ClientDetailsOverviewPage_ClientDetailsOverviewPageQuery' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const ClientDetailsOverviewPage_HouseholdMetricsFragmentDoc = gql`
    fragment ClientDetailsOverviewPage_HouseholdMetrics on HouseholdMetrics {
  totalEstateValue
  inEstateValue
  outOfEstateValue
  outOfEstateCharityValue
  outOfEstateFamilyValue
}
    `;
export const ClientDetailsOverviewPage_ClientDetailsOverviewPageQueryFragmentDoc = gql`
    fragment ClientDetailsOverviewPage_ClientDetailsOverviewPageQuery on ClientOverallPerformanceReport {
  totalWealthTransferred
  impliedEstateTaxSavings
}
    `;
export const ClientDetailsOverviewPage__ClientProfileFragmentDoc = gql`
    fragment ClientDetailsOverviewPage__ClientProfile on ClientProfile {
  id
  firstName
  lastName
  gstExclusionUsed
  displayName
  lifetimeExclusionUsed
  currentAnnualExclusionUsed
  totalAnnualExclusionUsed
  remainingStateExemption
  stateExemptionUsed
  totalStateExemption
  address {
    id
    stateCode
  }
  dsue {
    id
    amount
    eventDate
  }
}
    `;
export const ClientDetailsOverviewPage_HouseholdFragmentDoc = gql`
    fragment ClientDetailsOverviewPage_Household on Household {
  id
  displayName
  estateValueMetrics(source: {kind: HOUSEHOLD}) {
    ...ClientDetailsOverviewPage_HouseholdMetrics
  }
  clientPerformanceReport {
    ...ClientDetailsOverviewPage_ClientDetailsOverviewPageQuery
  }
  possiblePrimaryClients {
    ...ClientDetailsOverviewPage__ClientProfile
  }
  entities {
    totalCount
    edges {
      node {
        id
      }
    }
  }
}
    ${ClientDetailsOverviewPage_HouseholdMetricsFragmentDoc}
${ClientDetailsOverviewPage_ClientDetailsOverviewPageQueryFragmentDoc}
${ClientDetailsOverviewPage__ClientProfileFragmentDoc}`;
export const ClientDetailsOverviewPage_HouseholdAssetsSummaryFragmentDoc = gql`
    fragment ClientDetailsOverviewPage_HouseholdAssetsSummary on HouseholdAssetsSummary {
  liquidValue
  liquidPercentage
  inEstateLiquidValue
  inEstateLiquidPercentage
  outOfEstateLiquidValue
  outOfEstateLiquidPercentage
}
    `;
export const ClientDetailsOverviewPageDocument = gql`
    query ClientDetailsOverviewPage($householdId: ID!) {
  documents(first: 1, where: {hasHouseholdWith: [{id: $householdId}]}) {
    edges {
      node {
        id
      }
    }
  }
  households(where: {id: $householdId}) {
    edges {
      node {
        id
        ...ClientDetailsOverviewPage_Household
      }
    }
  }
  householdAssetsSummary(id: $householdId, source: {kind: HOUSEHOLD}) {
    ...ClientDetailsOverviewPage_HouseholdAssetsSummary
  }
}
    ${ClientDetailsOverviewPage_HouseholdFragmentDoc}
${ClientDetailsOverviewPage_HouseholdAssetsSummaryFragmentDoc}`;

/**
 * __useClientDetailsOverviewPageQuery__
 *
 * To run a query within a React component, call `useClientDetailsOverviewPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientDetailsOverviewPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientDetailsOverviewPageQuery({
 *   variables: {
 *      householdId: // value for 'householdId'
 *   },
 * });
 */
export function useClientDetailsOverviewPageQuery(baseOptions: Apollo.QueryHookOptions<ClientDetailsOverviewPageQuery, ClientDetailsOverviewPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientDetailsOverviewPageQuery, ClientDetailsOverviewPageQueryVariables>(ClientDetailsOverviewPageDocument, withFetchPolicyContext(options));
      }
export function useClientDetailsOverviewPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientDetailsOverviewPageQuery, ClientDetailsOverviewPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientDetailsOverviewPageQuery, ClientDetailsOverviewPageQueryVariables>(ClientDetailsOverviewPageDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useClientDetailsOverviewPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClientDetailsOverviewPageQuery, ClientDetailsOverviewPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientDetailsOverviewPageQuery, ClientDetailsOverviewPageQueryVariables>(ClientDetailsOverviewPageDocument, withFetchPolicyContext(options));
        }
export type ClientDetailsOverviewPageQueryHookResult = ReturnType<typeof useClientDetailsOverviewPageQuery>;
export type ClientDetailsOverviewPageLazyQueryHookResult = ReturnType<typeof useClientDetailsOverviewPageLazyQuery>;
export type ClientDetailsOverviewPageSuspenseQueryHookResult = ReturnType<typeof useClientDetailsOverviewPageSuspenseQuery>;
export type ClientDetailsOverviewPageQueryResult = Apollo.QueryResult<ClientDetailsOverviewPageQuery, ClientDetailsOverviewPageQueryVariables>;